$(document).ready(function() {

   window.REWARDS_MILESTONES = [
        {
            threshold: 5000,
            label: "Free Shipping",
            icon: {
                locked: "fas fa-lock",
                achieved: "fas fa-truck"
            },
            messages: {
                empty: "Spend <b>$50</b> to unlock <b>free shipping</b>!",
                progress: "You're only <b>{remaining}</b> away from <b>free shipping</b>!",
                achieved: "You've got <b>free shipping</b>!"
            }
        },
        {
            threshold: 12500,
            label: "Free Gift",
            icon: {
                locked: "fas fa-lock",
                achieved: "fas fa-gift"
            },
            messages: {
                empty: "You've got <b>free shipping</b>! Spend <b>$125</b> to unlock a free gift.",
                progress: "Free shipping unlocked! You're only <b>{remaining}</b> away from a <b>free gift</b>.",
                achieved: "🎉 You've unlocked <b>free shipping</b> + a <b>free gift</b>!"
            }
        }
    ];

    // Helper: centavos -> "$X" o "$X.XX"
    function moneyFromCents(cents) {
        var val = cents / 100;
        return "$" + (val % 1 === 0 ? val.toFixed(0) : val.toFixed(2));
    }

    // ===== 1) CONSTRUIR LA ESTRUCTURA UNA SOLA VEZ =====
    // Genera los segmentos con ancho 0. No se vuelve a llamar en cada update.
    window.buildRewardsProgress = function() {
        var $container = $("#rewards-progress");
        if (!$container.length) return;

        var milestones = window.REWARDS_MILESTONES;
        if (!milestones || !milestones.length) return;

        var $track = $container.find(".rewards-progress__track");
        if (!$track.length) return;

        // Si ya está construido, no lo rehacemos
        if ($track.data("built")) return;

        $track.empty();

        milestones.forEach(function(m, i) {
            var $segment = $('<div class="rewards-progress__segment" data-index="' + i + '"></div>');
            $segment.append(
                '<div class="rewards-progress__bar">' +
                    '<span class="rewards-progress__fill" style="width:0%"></span>' +
                '</div>'
            );
            $segment.append(
                '<div class="rewards-progress__node">' +
                    '<span class="rewards-progress__node-dot">' +
                        '<i class="rewards-progress__node-icon ' + m.icon.locked + '"></i>' +
                    '</span>' +
                    '<span class="rewards-progress__node-label">' + m.label + '</span>' +
                '</div>'
            );
            $track.append($segment);
        });

        $track.data("built", true);
    };

    // ===== 2) ACTUALIZAR (solo mueve anchos y cambia textos) =====
    // totalPrice llega en CENTAVOS (ej: 32130 = $321.30)
    window.updateRewardsProgress = function(totalPrice) {
        var $container = $("#rewards-progress");
        if (!$container.length) return;

        var milestones = window.REWARDS_MILESTONES;
        if (!milestones || !milestones.length) return;

        // Aseguramos que la estructura exista (por si no se construyó aún)
        window.buildRewardsProgress();

        var total = Number(totalPrice) || 0;
        var low = 0;
        var activeIndex = -1; // primer hito NO cumplido

        milestones.forEach(function(m, i) {
            var high = m.threshold;

            // % de llenado SOLO dentro de este tramo
            var fill;
            if (total <= low) {
                fill = 0;
            } else if (total >= high) {
                fill = 100;
            } else {
                fill = ((total - low) / (high - low)) * 100;
            }

            var achieved = total >= high;
            if (!achieved && activeIndex === -1) {
                activeIndex = i;
            }

            // Selectores de elementos YA existentes
            var $segment = $container.find('.rewards-progress__segment[data-index="' + i + '"]');
            var $fill = $segment.find(".rewards-progress__fill");
            var $node = $segment.find(".rewards-progress__node");

            // Animar el ancho con jQuery (suave, desde el valor actual)
            $fill.stop(true).animate({ width: fill + "%" }, 500);

            // Marcar nodo cumplido / pendiente + cambiar icono
            var $icon = $node.find(".rewards-progress__node-icon");
            if (achieved) {
                $node.addClass("is-achieved");
                $icon.attr("class", "rewards-progress__node-icon " + m.icon.achieved);
            } else {
                $node.removeClass("is-achieved");
                $icon.attr("class", "rewards-progress__node-icon " + m.icon.locked);
            }

            low = high;
        });

        // ===== MENSAJE (se sobrescribe según etapa activa) =====
        var $message = $container.find(".rewards-progress__message");
        var msgHtml = "";

        if (activeIndex === -1) {
            // Todos los hitos cumplidos -> logro del último
            msgHtml = milestones[milestones.length - 1].messages.achieved;
        } else {
            var active = milestones[activeIndex];
            if (total <= 0) {
                msgHtml = active.messages.empty;
            } else {
                var remaining = active.threshold - total;
                msgHtml = active.messages.progress.replace("{remaining}", moneyFromCents(remaining));
            }
        }

        $message.html(msgHtml);
    };

    // ===== Construir la estructura de inmediato al cargar =====
    window.buildRewardsProgress();

    // ===== RESTO DEL CÓDIGO ORIGINAL (sin cambios) =====
    $("#openModal").click(function() {
        $("#myModalCompleteLook").fadeIn(400, function() {
            window.dispatchEvent(new Event('resize'));
        });
    });
    $(".modal-complete-look__close").click(function() {
        $("#myModalCompleteLook").fadeOut();
        $("div#myModalCompleteLook #message-add-to-cart").fadeOut();
    });
    $(document).on("click","div#myModalCompleteLook.open-modal-rebuy .modal-complete-look__close",function() {
        $("div#myModalCompleteLook").removeClass('open-modal-rebuy');
    });
    $(document).click(function(event) {
        if ($(event.target).closest(".modal-complete-look__container").length === 0 && $(event.target).is(".modal-complete-look__content")) {
            $("#myModalCompleteLook").fadeOut();
            $("div#myModalCompleteLook #message-add-to-cart").fadeOut();
            if ($("div#myModalCompleteLook").hasClass('open-modal-rebuy')) {
                $("div#myModalCompleteLook").removeClass('open-modal-rebuy');
            }
        }
    });
});